// Analytics Configuration
export const analyticsConfig = {
  amplitude: {
    apiKey: import.meta.env.VITE_AMPLITUDE_API_KEY || "",
    enabled: import.meta.env.VITE_HOST_ENV === "production",
  },
};
